import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindUniversLandingContent($filter: String!)
{
  queryUniversLandingContents(top: 1, skip: 0, filter: $filter) {
    data {
      seoDescription {
        iv
      }
      seoKeywords {
        iv
      }
      seoThumbnail {
        iv {
          url
        }
      }
      universeTitle {
        iv
      }
      titleBlocTitle {
        iv
      }
      titleBlocFontSizeTitle {
        iv
      }
      titleBlocSubTitle {
        iv
      }
      titleBlocFontSizeSubTitle {
        iv
      }
      titleBlocWidth {
        iv
      }
      titleBlocTagline {
        iv
      }
      titleBlocTextColor {
        iv
      }
      titleBlocColor {
        iv
      }
      titleBlocCtaLink {
        iv
      }
      titleBlocCtaText {
        iv
      }
      titleBlocCtaStyle {
        iv
      }
      titleBlocCtaLink2 {
        iv
      }
      titleBlocCtaText2 {
        iv
      }
      titleBlocCtaStyle2 {
        iv
      }
      titleBlocPicture {
        iv {
          url
          fileSize
        }
      }
      titleBlocHorizontalPosition {
        iv
      }
      titleBlocVerticalPosition {
        iv
      }
      titleBlocJustification {
        iv
      }

      categories{
        iv{
          picture{
              url
              fileSize
          }
          pictureLink
          text
          highlight
        }
      }

      nouveautesCatalogue {
        iv{id}
      }

      newsSuperTitle {
        iv
      }
      actualite {
        iv { id }
      }

      tendanceSuperTitle {
        iv
      }
      tendance {
        iv{id}
      }

      preFooterPictureList{
        iv{
          picture{
              url
              fileSize
          }
          pictureLink
          text
        }
      }
      preFooterColor {
        iv
      }

      mention {
        iv
      }
      mentionFontSize {
        iv
      }
      mentionTextColor {
        iv
      }

    }
  }
}
`,
]);
